import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import {
  MatDatepickerInputEvent,
  MatDialog
} from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

@Component({
  selector: "app-payout",
  templateUrl: "./webhook-responses.component.html",
  styleUrls: ["./webhook-responses.component.css"],
})
export class WebhookResponsesComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
  };

  oPayouts: any = [];
  searchValue: string = "";
  filter: any = {
    page: 1,
    limit: 100,
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    userId: "",
    orderId: "",
  };
  prev_disabled = true;
  next_disabled = false;

  userList: any[] = [];
  filteredUserList: any[] = [];
  userSearchValue: string = "";
  isUserSelectOpen: boolean = false;

  myFilter = (d: Date | null): boolean => true;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadUserList() {
    if (!this._csrf) {
      return;
    }

    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: "",
      status: "Active",
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.userList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.userList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.userList = response.data;
        } else {
          this.userList = [];
        }
        this.filteredUserList = this.userList;
      },
      () => {
        this.userList = [];
        this.filteredUserList = [];
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        cellRenderer: (params) => {
          const viewBtn = document.createElement("button");
          viewBtn.type = "button";
          viewBtn.className = "btn btn-sm btn-info";
          viewBtn.title = "View";
          viewBtn.style.padding = "2px 8px";
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(params.data, "Webhook Response");
          };
          return viewBtn;
        },
        sortable: false,
        filter: false,
        flex: 0.6,
        minWidth: 80,
      },
      {
        headerName: "UserName",
        field: "UserId.name",
        valueGetter: (params) => (params.data && params.data.UserId && params.data.UserId.name) || "",
        flex: 1,
      },
      { headerName: "Type", field: "UpdateType", flex: 1 },
      // Records saved before these fields existed: read them from the sent data
      {
        headerName: "OrderId",
        field: "OrderId",
        valueGetter: (params) => this.orderValue(params.data, "OrderId"),
        flex: 1.5,
      },
      {
        headerName: "ClientOrderId",
        field: "ClientOrderId",
        valueGetter: (params) => this.orderValue(params.data, "ClientOrderId"),
        flex: 1.5,
      },
      {
        headerName: "PaymentStatus",
        field: "PaymentStatus",
        valueGetter: (params) => this.orderValue(params.data, "PaymentStatus"),
        flex: 1,
      },
      // Failure code / reason the client got (FAILED / REJECTED only), as sent in the callback
      {
        headerName: "FailureCode",
        field: "FailureCode",
        valueGetter: (params) => {
          const sent = (params.data && params.data.UpdateData) || {};
          if (!sent.FailureCode) return "";
          return sent.FailureReason ? `${sent.FailureCode} - ${sent.FailureReason}` : sent.FailureCode;
        },
        tooltipValueGetter: (params) => params.value,
        flex: 1.8,
      },
      { headerName: "Status", field: "Status", flex: 0.8 },
      { headerName: "ResStatus", field: "ResponseStatus", flex: 0.8 },
      { headerName: "ResMessage", field: "ResponseMessage", flex: 1.5 },
      { headerName: "WebHookUrl", field: "WebHookUrl", flex: 2 },
      { headerName: "KeyName", field: "KeyName", flex: 1 },
      { headerName: "APIKey", field: "ApiKey", flex: 1.5 },
      {
        headerName: "UpdatedAt",
        field: "updatedAt",
        valueFormatter: (params) => params.value ? moment(params.value).format("MMM DD, YYYY hh:mm:ss A") : "",
        flex: 1.5,
      },
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  }

  orderValue(row: any, field: string): string {
    if (!row) return "";
    if (row[field]) return row[field];
    const sent = row.UpdateData || {};
    if (field === "OrderId") return sent.OrderId || sent._id || "";
    return sent[field] || "";
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadUserList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext() {
    this.filter.page++;
    this.getData();
  }

  goPrev() {
    if (this.filter.page > 1) {
      this.filter.page--;
      this.getData();
    }
  }

  // A new search starts from page 1 so the new filter isn't applied to a later page
  search() {
    this.filter.page = 1;
    this.getData();
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || "";
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
  }

  clearSearch() {
    this.applyFilter("");
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      userId: "",
      orderId: "",
    };
    this.userSearchValue = "";
    this.filteredUserList = this.userList;
    this.applyFilter("");
    this.getData();
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getWebhookResponses(this.filter).subscribe(
      (list: any) => {
        this.oPayouts = list || [];
        this.rowData = this.oPayouts;

        if (this.gridApi) {
          this.gridApi.setRowData(this.rowData);
          this.gridApi.setQuickFilter(this.searchValue);
        }

        this.spinnerService.hide();
        this.prev_disabled = this.filter.page <= 1;
        this.next_disabled = !list || list.length < this.filter.limit;
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  exportArray() {
    this.spinnerService.show();

    // Fetch fresh with a large limit (ignoring current page) so the export isn't capped to one page
    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      userId: this.filter.userId || "",
      orderId: this.filter.orderId || "",
      page: 1,
      limit: 5000,
    };

    this.userService.getWebhookResponses(exportFilter).subscribe(
      (list: any) => {
        if (list && list.length > 0) {
          const exportData = list.map((x: any) => ({
            ...x,
            UserId: x.UserId ? x.UserId._id : '',
            UserName: x.UserId ? x.UserId.name : '',
            UpdateData: x.UpdateData ? JSON.stringify(x.UpdateData) : '',
          }));
          TableUtil.exportArrayToExcel(exportData, 'WebhookResponses');
        } else {
          this.notifSer.info("Info", "No data available to export", {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          });
        }
        this.spinnerService.hide();
      },
      () => {
        this.notifSer.error("Error", "Failed to export data. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.spinnerService.hide();
      }
    );
  }

  onUserSelectOpened(isOpen: boolean) {
    this.isUserSelectOpen = isOpen;
    this.userSearchValue = "";
    this.filteredUserList = this.userList;
    if (isOpen) {
      setTimeout(() => {
        this.addSearchToSelectPanel();
      }, 150);
    }
  }

  addSearchToSelectPanel() {
    const panel = document.querySelector(".user-select-panel-webhook-responses");
    if (panel) {
      const existingSearch = panel.querySelector(".user-search-container");
      if (existingSearch) {
        existingSearch.remove();
      }

      const searchContainer = document.createElement("div");
      searchContainer.className = "user-search-container";
      searchContainer.innerHTML = `
        <input type="text" placeholder="Search user..." class="user-search-input" value="${this.userSearchValue || ""}">
      `;

      const searchInput = searchContainer.querySelector(".user-search-input") as HTMLInputElement;
      if (searchInput) {
        searchInput.addEventListener("input", (e: any) => {
          this.userSearchValue = e.target.value;
          this.filterUsers(e);
        });
        searchInput.addEventListener("click", (e: any) => {
          e.stopPropagation();
        });
        searchInput.addEventListener("keydown", (e: any) => {
          e.stopPropagation();
        });
      }

      if (panel.firstChild) {
        panel.insertBefore(searchContainer, panel.firstChild);
      } else {
        panel.appendChild(searchContainer);
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 50);
      }
    }
  }

  filterUsers(event: any) {
    const searchTerm = event ? (event.target ? event.target.value : event) : this.userSearchValue;
    this.userSearchValue = searchTerm || "";

    if (!searchTerm || searchTerm.trim() === "") {
      this.filteredUserList = this.userList;
      return;
    }

    const term = searchTerm.toLowerCase();
    this.filteredUserList = this.userList.filter((user) => {
      const name = (user.name || "").toLowerCase();
      const email = (user.email || "").toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
      jsonData: jsonData,
      eventType: eventType || "webhook response"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/webhook-responses/webhook-responses.component.ts